// // // socket.js
// // import { io } from 'socket.io-client';

// // const WS_URL = 'wss://procam.pythonanywhere.com/';

// // // Initialize socket connection
// // export const socket = io(WS_URL, { transports: ['websocket'] });

// // // Join a user room
// // export function joinUserRoom(user_id) {
// //   socket.emit('join', { user_id });
// // }

// // // Leave a user room
// // export function leaveUserRoom(user_id) {
// //   socket.emit('leave', { user_id });
// // }

// // // Send a message (single or broadcast)
// // export function sendMessage(data, callback) {
// //   socket.emit('send_message', data);
// //   if (callback) socket.once('send_message_result', callback);
// // }

// // // Get unread messages
// // export function getUnreadMessages({ event_id, user_id }, callback) {
// //   socket.emit('get_unread_messages', { event_id, user_id });
// //   socket.once('get_unread_messages_result', callback);
// // }

// // // Get all messages (sent and received)
// // export function getAllMessages({ event_id, user_id }, callback) {
// //   socket.emit('get_all_messages', { event_id, user_id });
// //   socket.once('get_all_messages_result', callback);
// // }

// // // Mark a message as read
// // export function markMessageRead(msg_id, callback) {
// //   socket.emit('mark_message_read', { msg_id });
// //   socket.once('mark_message_read_result', callback);
// // }

// // // Get users by role
// // export function getUsersByRole(role, callback) {
// //   socket.emit('get_users_by_role', { role });
// //   socket.once('get_users_by_role_result', callback);
// // }



// // // socket.js
// // // import { io } from 'socket.io-client';

// // // const WS_URL = 'wss://procam.pythonanywhere.com/';

// // // // Initialize socket connection
// // // export const socket = io(WS_URL, { 
// // //   transports: ['websocket'],
// // //   forceNew: true,
// // //   reconnection: true,
// // //   timeout: 20000,
// // // });

// // // // Join a user room
// // // export function joinUserRoom(user_id) {
// // //   socket.emit('join', { user_id });
// // // }

// // // // Leave a user room
// // // export function leaveUserRoom(user_id) {
// // //   socket.emit('leave', { user_id });
// // // }

// // // // Send a message (single or broadcast)
// // // export function sendMessage(data, callback) {
// // //   socket.emit('send_message', data);
// // //   if (callback) socket.once('send_message_result', callback);
// // // }

// // // // Get unread messages
// // // export function getUnreadMessages({ event_id, user_id }, callback) {
// // //   socket.emit('get_unread_messages', { event_id, user_id });
// // //   socket.once('get_unread_messages_result', callback);
// // // }

// // // // Get all messages (sent and received)
// // // export function getAllMessages({ event_id, user_id }, callback) {
// // //   socket.emit('get_all_messages', { event_id, user_id });
// // //   socket.once('get_all_messages_result', callback);
// // // }

// // // // Mark a message as read
// // // export function markMessageRead(msg_id, callback) {
// // //   socket.emit('mark_message_read', { msg_id });
// // //   socket.once('mark_message_read_result', callback);
// // // }

// // // // Get users by role
// // // export function getUsersByRole(role, callback) {
// // //   socket.emit('get_users_by_role', { role });
// // //   socket.once('get_users_by_role_result', callback);
// // // }

// // // // Upload files function
// // // export function uploadFiles(fileData, callback) {
// // //   socket.emit('upload_files', fileData);
// // //   socket.once('upload_files_result', callback);
// // // }



// // // import { io } from 'socket.io-client';

// // // const WS_URL = 'wss://procam.pythonanywhere.com/';

// // // // Initialize socket connection
// // // export const socket = io(WS_URL, { 
// // //   transports: ['websocket'],
// // //   forceNew: false,
// // //   reconnection: true,
// // //   reconnectionAttempts: 5,
// // //   reconnectionDelay: 1000,
// // //   timeout: 20000,
// // //   autoConnect: true
// // // });

// // // // Connection event handlers
// // // socket.on('connect', () => {
// // //   console.log('Socket connected:', socket.id);
// // // });

// // // socket.on('disconnect', (reason) => {
// // //   console.log('Socket disconnected:', reason);
// // // });

// // // socket.on('connect_error', (error) => {
// // //   console.error('Socket connection error:', error);
// // // });

// // // socket.on('reconnect', (attemptNumber) => {
// // //   console.log('Socket reconnected after', attemptNumber, 'attempts');
// // // });

// // // socket.on('reconnect_error', (error) => {
// // //   console.error('Socket reconnection error:', error);
// // // });

// // // // Join a user room
// // // export function joinUserRoom(user_id) {
// // //   console.log('Joining user room for user:', user_id);
// // //   socket.emit('join', { user_id });
// // // }

// // // // Leave a user room
// // // export function leaveUserRoom(user_id) {
// // //   console.log('Leaving user room for user:', user_id);
// // //   socket.emit('leave', { user_id });
// // // }

// // // // Send a message (single or broadcast)
// // // export function sendMessage(data, callback) {
// // //   console.log('Sending message via socket:', data);

// // //   // Always attach a listener first to avoid missing the server response
// // //   const handler = (result) => {
// // //     console.log('send_message_result (text-only):', result); // your log
// // //     if (callback) callback(result);
// // //   };

// // //   // Use `once` to listen only for the next result, then remove automatically
// // //   socket.onAny('send_message_result', handler);

// // //   socket.emit('send_message', data);
// // // }

// // // // Get unread messages
// // // export function getUnreadMessages({ event_id, user_id }, callback) {
// // //   socket.emit('get_unread_messages', { event_id, user_id });
// // //   socket.once('get_unread_messages_result', callback);
// // // }

// // // // Get all messages (sent and received)
// // // export function getAllMessages({ event_id, user_id }, callback) {
// // //   socket.emit('get_all_messages', { event_id, user_id });
// // //   socket.once('get_all_messages_result', callback);
// // // }

// // // // Mark a message as read
// // // export function markMessageRead(msg_id, callback) {
// // //   socket.emit('mark_message_read', { msg_id });
// // //   if (callback) {
// // //     socket.once('mark_message_read_result', callback);
// // //   }
// // // }

// // // // Get users by role
// // // export function getUsersByRole(role, callback) {
// // //   socket.emit('get_users_by_role', { role });
// // //   socket.once('get_users_by_role_result', callback);
// // // }

// // // // Upload files function
// // // export function uploadFiles(fileData, callback) {
// // //   socket.emit('upload_files', fileData);
// // //   if (callback) {
// // //     socket.once('upload_files_result', callback);
// // //   }
// // // }

// // // // Message event listeners setup
// // // export function setupMessageListeners({ onNewMessage, onMessageRead, onMessageDelivered }) {
// // //   if (onNewMessage) {
// // //     socket.on('new_message', onNewMessage);
// // //   }
// // //   if (onMessageRead) {
// // //     socket.on('message_read', onMessageRead);
// // //   }
// // //   if (onMessageDelivered) {
// // //     socket.on('message_delivered', onMessageDelivered);
// // //   }
// // // }

// // // // Remove message event listeners
// // // export function removeMessageListeners({ onNewMessage, onMessageRead, onMessageDelivered }) {
// // //   if (onNewMessage) {
// // //     socket.off('new_message', onNewMessage);
// // //   }
// // //   if (onMessageRead) {
// // //     socket.off('message_read', onMessageRead);
// // //   }
// // //   if (onMessageDelivered) {
// // //     socket.off('message_delivered', onMessageDelivered);
// // //   }
// // // }

// // // // Typing indicators
// // // export function startTyping(data) {
// // //   socket.emit('typing_start', data);
// // // }

// // // export function stopTyping(data) {
// // //   socket.emit('typing_stop', data);
// // // }

// // // // Setup typing listeners
// // // export function setupTypingListeners({ onUserTyping, onUserStoppedTyping }) {
// // //   if (onUserTyping) {
// // //     socket.on('user_typing', onUserTyping);
// // //   }
// // //   if (onUserStoppedTyping) {
// // //     socket.on('user_stopped_typing', onUserStoppedTyping);
// // //   }
// // // }

// // // // Remove typing listeners
// // // export function removeTypingListeners({ onUserTyping, onUserStoppedTyping }) {
// // //   if (onUserTyping) {
// // //     socket.off('user_typing', onUserTyping);
// // //   }
// // //   if (onUserStoppedTyping) {
// // //     socket.off('user_stopped_typing', onUserStoppedTyping);
// // //   }
// // // }

// // // // Check socket connection status
// // // export function isSocketConnected() {
// // //   return socket.connected;
// // // }

// // // // Get socket ID
// // // export function getSocketId() {
// // //   return socket.id;
// // // }

// // // // Reconnect manually
// // // export function reconnectSocket() {
// // //   if (!socket.connected) {
// // //     socket.connect();
// // //   }
// // // }

// // // // Disconnect socket
// // // export function disconnectSocket() {
// // //   socket.disconnect();
// // // }

// // // export default socket;




// import { io } from 'socket.io-client';

// const SOCKET_URL = 'ws://procam.pythonanywhere.com';

// // export const socket = io(SOCKET_URL, {
// //   transports: ['websocket']
// // });

// const socket = io("https://procam.pythonanywhere.com", {
//   transports: ["polling"],   // disable websockets
//   reconnection: true,
//   reconnectionDelay: 2000
// });

// export default socket;


import { io } from "socket.io-client";

// ✅ point to your backend server, not localhost
const socket = io(process.env.REACT_APP_SOCKET_URL, {
  path: "/socket.io/",   // must match Flask-SocketIO path
  transports: ["websocket"], // force WebSocket (avoid polling issues)
  withCredentials: true,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 500,
});

export const joinRoom = (userId) => {
  socket.emit("join", { user_id: userId });
  console.log(`Joined room for user_${userId}`);
};


export default socket;